import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { AnimatePresence } from "framer-motion";
import { HeadingIcon } from "./heading-icon";
import { HeadingText } from "./heading-text";
import { type UseCaseAnimationProps } from ".";

const HEADING_HEIGHT = { base: "18px", sm: "24px", md: "28px" };

function UseCaseHeading({
  useCases,
  isHero,
  activeAnimationIndex,
  isFirstLoop,
}: UseCaseAnimationProps & { activeAnimationIndex: number; isFirstLoop: boolean }) {
  const { head } = useCases[activeAnimationIndex];

  return (
    <Flex w="100%">
      <Flex flex={2} gap={{ base: 2, md: 3 }} align="center">
        <Box pos="relative" boxSize={HEADING_HEIGHT}>
          <AnimatePresence>
            {head.source && (
              <HeadingIcon
                key={`${head.source.slug}-${activeAnimationIndex}`}
                src={head.source.iconUrl}
                alt={head.source.name}
                priority={isHero}
              />
            )}
          </AnimatePresence>
        </Box>

        <Box pos="relative" flex="1" minW={0} h={HEADING_HEIGHT}>
          <AnimatePresence>
            <HeadingText key={`${head.sourceTitle}-${activeAnimationIndex}`} isFirstLoop={isFirstLoop}>
              {head.sourceTitle}
            </HeadingText>
          </AnimatePresence>
        </Box>
      </Flex>

      <Box flex={{ base: 0.75, md: 1 }} />

      <Flex flex={2} gap={{ base: 2, md: 3 }} align="center" border="1.5px solid transparent">
        <Box pos="relative" boxSize={HEADING_HEIGHT}>
          <AnimatePresence>
            {head.destination && (
              <HeadingIcon
                key={`${head.destination.slug}-${activeAnimationIndex}`}
                src={head.destination.iconUrl}
                alt={head.destination.name}
                priority={isHero}
                isFirstLoop={isFirstLoop}
              />
            )}
          </AnimatePresence>
        </Box>

        <Box pos="relative" flex="1" minW={0} h={HEADING_HEIGHT}>
          <AnimatePresence>
            <HeadingText key={`${head.destinationTitle}-${activeAnimationIndex}`} isFirstLoop={isFirstLoop}>
              {head.destinationTitle}
            </HeadingText>
          </AnimatePresence>
        </Box>
      </Flex>
    </Flex>
  );
}

export default UseCaseHeading;
